import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEllipsisV } from "@fortawesome/free-solid-svg-icons";
import { Link } from "react-router-dom";
import { BodyAsFormData, Url } from "../../../services/utilities/util";
import FilterContext from "../../../routes/FilterContext";
import { apiMiddleware } from "../../../services/apis/apiMiddleware";
import { connect } from "react-redux";
import Preload from "image-preload";
Preload(["/edge/images/updated_logos/officestock.svg"]);
function mapStateToProps(state) {
  return { filters: state.selectedFilters };
}
class TotalOfficeStockBuiltDeveloper extends React.Component {
  static contextType = FilterContext;

  state = {
    sumOfChargeableArea: 0,
    noOfComplexes: 0,
    filters: "",
    urlFilter: "",
  };

  constructor(props) {
    super(props);
  }

  componentDidMount() {
    var filters;
    if (JSON.stringify(this.props.filters) == "{}") {
      filters = JSON.stringify(this.context.filters);
    } else {
      filters = JSON.stringify(this.props.filters);
    }
    this.state.filters = filters;
    apiMiddleware
      .post(
        "api/edge/office/get_total_office_stock_build",
        BodyAsFormData(filters)
      )
      .then((res) => {
        this.setState({
          sumOfChargeableArea: res.data.sum_of_chargeable_area,
          noOfComplexes: res.data.no_of_complxes,
        });
      });

    if (Url.get.filter != undefined) {
      // console.log(Url.get.filter);
      var todayDate = new Date().toISOString();
      const covLink = JSON.parse(Url.get.filter);
      covLink["end_occupancy_date_orig"] = todayDate;
      console.log(JSON.stringify(covLink));
      this.setState({
        urlFilter: "?filter=" + JSON.stringify(covLink),
      });
    } else {
      this.setState({
        urlFilter: "",
      });
    }
  }

  componentDidUpdate() {
    if (this.props.filters != this.state.filters) {
      this.setState({ filters: this.props.filters });

      apiMiddleware
        .post(
          "api/edge/office/get_total_office_stock_build",
          BodyAsFormData(JSON.stringify(this.props.filters))
        )
        .then((res) => {
          this.setState({
            sumOfChargeableArea: res.data.sum_of_chargeable_area,
            noOfComplexes: res.data.no_of_complxes,
          });
        });

      if (Url.get.filter != undefined) {
        // console.log(Url.get.filter);
        var todayDate = new Date().toISOString();
        const covLink = JSON.parse(Url.get.filter);
        covLink["end_occupancy_date_orig"] = todayDate;
        console.log(JSON.stringify(covLink));
        this.setState({
          urlFilter: "?filter=" + JSON.stringify(covLink),
        });
      } else {
        this.setState({
          urlFilter: "",
        });
      }
    }
  }

  render() {
    return (
      <Link to={`/office/asset/${this.state.urlFilter}`} target="_blank">
        <div className="newWidgetClass">
          <img
            alt="Total Office Stock Built Icon"
            src="/edge/images/updated_logos/officestock.svg"
            className="imgWidth100"
          />
          <div className="colorBlue">
            <h2>
              {this.state.sumOfChargeableArea} msf{" "}
              <span>({this.state.noOfComplexes} Assets)</span>
            </h2>

            <p>Total Office Stock Built</p>
          </div>
        </div>
      </Link>
    );
  }
}

export default connect(mapStateToProps)(TotalOfficeStockBuiltDeveloper);
